var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticClass:"py-0 px-0 mod--background_transparent"},[_c('app-bar',{attrs:{"numberSelected":_vm.numberSelected}}),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }